import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-package-change-requests',
  templateUrl: './package-change-requests.component.html',
  styleUrls: ['./package-change-requests.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageChangeRequestsComponent {}
